<template>
    <div id="ap">
        <a-layout>
            <div class="content-header">
                <a-affix :offset-top="0" style="width: 100%;">
                    <a-row type="flex" :gutter="15">
                        <a-col span="4">
                            <a-input v-model="param.keyword" allowClear search @pressEnter="getList" @on-clear="getList"
                                placeholder="关键词查询"></a-input>
                        </a-col>
                        <a-col span="4">
                            <a-range-picker :placeholder="['开始日期', '截止日期']" @change="setDateRange" />
                        </a-col>
                    </a-row>
                </a-affix>
            </div>
        </a-layout>

        <a-layout>
            <a-layout-content>
                <a-table :defaultExpandAllRows="true" :scroll="{ x: '100%' }" :pagination="false" :indentSize="25"
                    :style="{ background: '#FFF' }" size="small" row-key="id" border :columns="keys" ref="list"
                    :loading="loading" :data-source="data.records">
                    <!--操作-->
                    <template slot-scope="row" slot="action">
                        <a-button-group shape="circle" size="small">
                            <a-tooltip title="编辑"><a-button type="link" v-has="'staff:save'" icon="edit"
                                    @click="$refs.staffForm._show(row)"></a-button></a-tooltip>
                            <a-tooltip title="删除" v-if="row.organId > 0"><a-button type="link" v-has="'staff:del'"
                                    icon="delete" @click="del(row.depId)"></a-button></a-tooltip>
                        </a-button-group>
                    </template>
                </a-table>
            </a-layout-content>
        </a-layout>
        <a-row>
            <a-col span="12" offset="6" style="text-align: center; padding: 20px 0;">
                <a-pagination :defaultPageSize="param.limit" :total="data.total" @change="getNext"
                    @showSizeChange="setLimit" :current="data.current" />
            </a-col>
        </a-row>
        <a-back-top />

    </div>
</template>

<script>
import utils from '@/common/utils';
export default {
    data() {
        return {
            loading: false,
            data: [],
            date: [],
            param: {
                page: 1,
                limit: 20,
                startDate: '',
                endDate: '',
                keyword: ''
            },
            keys: [
                { title: '操作时间', dataIndex: 'createTime', width: 180, align: 'center' },
                { title: '操作人', dataIndex: 'username', width: 220, ellipsis: true },
                { title: '操作', dataIndex: 'operation', align: 'left', ellipsis: true },
                { title: 'IP', dataIndex: 'ip', width: 200, align: 'left', ellipsis: true },
                // { title: '操作', scopedSlots: { customRender: 'action' }, align: 'center', width: 200 }
            ]
        };
    },
    created() {
        this.getList();
    },
    methods: {
        // 获取数据
        getList() {
            this.loading = true;
            this.http
                .get('/platform/logs/list', this.param)
                .then(ret => {
                    this.data = ret.data;
                    this.loading = false;
                })
                .catch(err => {
                    this.loading = false;
                });
        },
        setDateRange(data, str) {
            this.param.startDate = str[0];
            this.param.endDate = str[1];
            this.param.page = 1;
            this.getList();
        },
        //设置每页的显示条数
        setLimit(current, limit) {
            this.param.page = 1;
            this.param.limit = limit;
            this.getList();
        },
        //页码切换
        getNext(page) {
            this.param.page = page;
            this.getList();
        }
    }
};
</script>

<style scoped></style>
